import { generateTestId } from "@client-shared";

export const setCreateBatchDialogTestId = (identifier: string): string =>
  generateTestId("CreateBatchDialog", identifier);
